/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { TInspectorNode } from "../InspectorNodeTypes";
import { ISchemaBuilderIntegerModel, isSchemaBuilderIntegerModel } from "@adapptio/lib-blueprint";
import { mapModelToNodes } from "../index";

export function builderIntegerMapper(model: ISchemaBuilderIntegerModel): TInspectorNode {
	if (!isSchemaBuilderIntegerModel(model)) {
		return;
	}

	return mapModelToNodes(model.props);
}
